import { render, staticRenderFns } from "./tingliHome.vue?vue&type=template&id=93ea0e1e&scoped=true"
import script from "./tingliHome.vue?vue&type=script&lang=js"
export * from "./tingliHome.vue?vue&type=script&lang=js"
import style0 from "./tingliHome.vue?vue&type=style&index=0&id=93ea0e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ea0e1e",
  null
  
)

export default component.exports